export default __webpack_public_path__ + "static/media/drone.482d6987.svg";